import { useState, type FormEvent } from "react";
import { api, ApiHatasi, tarih, type Paket } from "../api";
import { Bildirim, Durum, HataKutusu, Kart, Rozet, Tablo, useCek } from "../ui";

export function Musteriler({ git }: { git: (yol: string) => void }) {
  const liste = useCek(() => api.musteriler(), []);
  const paketler = useCek(() => api.paketler(), []);
  const [yeni, setYeni] = useState(false);

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Müşteriler</h1>
          <p>Her müşteri bir kiracıdır: alan adları, kutuları ve limitleri birbirinden yalıtılmıştır.</p>
        </div>
        <div className="eylemler">
          <button className="dugme ana" onClick={() => setYeni((v) => !v)}>
            {yeni ? "Vazgeç" : "Yeni müşteri"}
          </button>
        </div>
      </div>

      {yeni && (
        <div style={{ marginBottom: 18 }}>
          <YeniMusteri
            paketler={paketler.veri?.veri ?? {}}
            bitti={() => {
              setYeni(false);
              liste.yenile();
            }}
          />
        </div>
      )}

      <Kart>
        <Durum cekim={liste} bos="Henüz müşteri yok">
          {(l) =>
            l.veri.length === 0 ? (
              <div className="bos">Henüz müşteri yok. Sağ üstten ekleyebilirsiniz.</div>
            ) : (
              <Tablo basliklar={["Müşteri", "Yetkili", "Paket", "Panel adresi", "Durum", "Eklendi", ""]}>
                {l.veri.map((m) => (
                  <tr key={m.id}>
                    <td>
                      <strong>{m.ad}</strong>
                      <div className="tek">{m.id}</div>
                    </td>
                    <td>
                      {m.yetkili_ad ?? "—"}
                      <div style={{ color: "var(--n-500)", fontSize: 12 }}>{m.yetkili_eposta ?? ""}</div>
                    </td>
                    <td>
                      <Rozet tur="marka">{m.paket}</Rozet>
                    </td>
                    <td className="tek">{m.panel_alan ?? "—"}</td>
                    <td>
                      {m.durum === "aktif" ? <Rozet tur="iyi">aktif</Rozet> : <Rozet tur="kotu">askıda</Rozet>}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{tarih(m.olusturma)}</td>
                    <td>
                      <button className="dugme kucuk" onClick={() => git("/musteriler/" + m.id)}>
                        aç
                      </button>
                    </td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}

function YeniMusteri({ paketler, bitti }: { paketler: Record<string, Paket>; bitti: () => void }) {
  const [g, setG] = useState({
    ad: "",
    yetkiliAd: "",
    yetkiliEposta: "",
    telefon: "",
    paket: "baslangic",
    panelAlan: "",
  });
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  const alan = (k: keyof typeof g) => ({
    value: g[k],
    onChange: (e: any) => setG({ ...g, [k]: e.target.value }),
  });

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setBekliyor(true);
    try {
      await api.musteriAc(g);
      bitti();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Kart baslik="Yeni müşteri">
      <form className="ic" onSubmit={gonder}>
        {hata && <HataKutusu hata={hata} />}
        <div className="izgara d2">
          <label className="alan">
            <span>Müşteri adı *</span>
            <input {...alan("ad")} required autoFocus placeholder="Umurbey Belediyesi" />
          </label>
          <label className="alan">
            <span>Paket *</span>
            <select {...alan("paket")}>
              {Object.entries(paketler).map(([ad, p]) => (
                <option key={ad} value={ad}>
                  {ad} — {p.kutu ?? "sınırsız"} kutu, {p.gunlukAlici} alıcı/gün
                </option>
              ))}
            </select>
          </label>
          <label className="alan">
            <span>Yetkili adı</span>
            <input {...alan("yetkiliAd")} placeholder="Ad Soyad" />
          </label>
          <label className="alan">
            <span>Yetkili e-postası *</span>
            <input type="email" {...alan("yetkiliEposta")} required placeholder="yetkili@baskaadres.com" />
            <small>
              Bu adres <strong>başka bir alan adında</strong> olmalı. Müşterinin kendi postası çöktüğünde
              parola sıfırlama bağlantısı buraya gider.
            </small>
          </label>
          <label className="alan">
            <span>Telefon</span>
            <input {...alan("telefon")} placeholder="+90 …" />
          </label>
          <label className="alan">
            <span>Kendi panel adresi</span>
            <input {...alan("panelAlan")} placeholder="mailpanel.musteri.com" />
            <small>Müşteri paneli bu adresten açılır. Sonradan da eklenebilir.</small>
          </label>
        </div>
        <Bildirim>
          Kiracı hem Stalwart tarafında hem panelde oluşturulur. İşlem yarıda kalırsa
          <strong> Denetim → yarıda kalanlar</strong> ekranında görünür.
        </Bildirim>
        <button className="dugme ana" disabled={bekliyor}>
          {bekliyor ? "Oluşturuluyor…" : "Müşteriyi oluştur"}
        </button>
      </form>
    </Kart>
  );
}
